class SiteService {
    public isHT(structureIds: number[]): boolean {
        return !!structureIds.filter(structureId => structureId === 11).length;
    }

    public isAlvazzi(structureIds: number[]): boolean {
        return !!structureIds.filter(structureId => structureId === 81 || structureId === 82 || structureId === 83
            || structureId === 87 || structureId === 88 || structureId === 89).length;
    }
}

export default new SiteService();
